/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { AssignEquipmentCommand } from '../model'
// @ts-ignore
import type { AssignedCraneForContainerDto } from '../model'
// @ts-ignore
import type { BulkEquipmentAssignmentCommand } from '../model'
// @ts-ignore
import type { CraneQueueDto } from '../model'
// @ts-ignore
import type { CreateEquipmentCommand } from '../model'
// @ts-ignore
import type { EquipmentDto } from '../model'
// @ts-ignore
import type { EquipmentForTallymanSelectionDto } from '../model'
// @ts-ignore
import type { EquipmentPlannedDto } from '../model'
// @ts-ignore
import type { EquipmentStatsDto } from '../model'
// @ts-ignore
import type { EquipmentType } from '../model'
// @ts-ignore
import type { LastEquipmentInteractionDto } from '../model'
// @ts-ignore
import type { OperationalEquipmentDto } from '../model'
// @ts-ignore
import type { ReleaseUsersEquipmentCommand } from '../model'
// @ts-ignore
import type { TallymanConfirmCraneDischargeJobCommand } from '../model'
// @ts-ignore
import type { TallymanConfirmCraneLoadingJobCommand } from '../model'
// @ts-ignore
import type { UnassignEquipmentCommand } from '../model'
// @ts-ignore
import type { UpdateEquipmentCommand } from '../model'
// @ts-ignore
import type { UpdateEquipmentResponsibleUserCommand } from '../model'
/**
 * EquipmentsApi - axios parameter creator
 */
export const EquipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('_delete', 'id', id)
      const localVarPath = `/operations/api/Equipments/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {AssignEquipmentCommand} [assignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assign: async (
      assignEquipmentCommand?: AssignEquipmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/assign`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignEquipmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {TallymanConfirmCraneDischargeJobCommand} [tallymanConfirmCraneDischargeJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignToJobByTallyman: async (
      tallymanConfirmCraneDischargeJobCommand?: TallymanConfirmCraneDischargeJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/assignToJobByTallyman`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        tallymanConfirmCraneDischargeJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {BulkEquipmentAssignmentCommand} [bulkEquipmentAssignmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkEquipmentAssignmentCommand: async (
      bulkEquipmentAssignmentCommand?: BulkEquipmentAssignmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/bulkEquipmentAssignmentCommand`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkEquipmentAssignmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    craneQueueStats: async (
      currentDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getCraneQueueStats`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (currentDate !== undefined) {
        localVarQueryParameter['CurrentDate'] =
          (currentDate as any) instanceof Date ? (currentDate as any).toISOString() : currentDate
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateEquipmentCommand} [createEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createEquipmentCommand?: CreateEquipmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createEquipmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    equipmentStats: async (
      currentDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getEquipmentStats`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (currentDate !== undefined) {
        localVarQueryParameter['CurrentDate'] =
          (currentDate as any) instanceof Date ? (currentDate as any).toISOString() : currentDate
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {EquipmentType} [equipmentType]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      vesselVisitId?: number,
      equipmentType?: EquipmentType,
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (vesselVisitId !== undefined) {
        localVarQueryParameter['VesselVisitId'] = vesselVisitId
      }

      if (equipmentType !== undefined) {
        localVarQueryParameter['EquipmentType'] = equipmentType
      }

      if (includeInactive !== undefined) {
        localVarQueryParameter['IncludeInactive'] = includeInactive
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedCranesForContainersByVisit: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getAssignedCranesForContainersByVisit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEquipmentTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getEquipmentTypes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [craneId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForTallymanOfDischarging: async (
      carrierVisitId?: number,
      craneId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getForTallymanOfDischarging`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      if (craneId !== undefined) {
        localVarQueryParameter['CraneId'] = craneId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [visitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIdsAlreadyInUseByOtherVisits: async (
      visitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getIdsAlreadyInUseByOtherVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (visitId !== undefined) {
        localVarQueryParameter['VisitId'] = visitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLast: async (id?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getLastEquipmentInteractionById`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (id !== undefined) {
        localVarQueryParameter['Id'] = id
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOne: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getOne', 'id', id)
      const localVarPath = `/operations/api/Equipments/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOperationalEquipments: async (
      ids?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getOperationalEquipments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['Ids'] = ids
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanned: async (
      carrierVisitId?: number,
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/getPlannedByVesselVisit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      if (includeInactive !== undefined) {
        localVarQueryParameter['IncludeInactive'] = includeInactive
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ReleaseUsersEquipmentCommand} [releaseUsersEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutOperatorEquipment: async (
      releaseUsersEquipmentCommand?: ReleaseUsersEquipmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/logoutOperatorEquipment`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        releaseUsersEquipmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {TallymanConfirmCraneLoadingJobCommand} [tallymanConfirmCraneLoadingJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tallymanConfirmCraneLoadingJob: async (
      tallymanConfirmCraneLoadingJobCommand?: TallymanConfirmCraneLoadingJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/tallymanConfirmCraneLoadingJob`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        tallymanConfirmCraneLoadingJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UnassignEquipmentCommand} [unassignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassign: async (
      unassignEquipmentCommand?: UnassignEquipmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/unassign`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        unassignEquipmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateEquipmentCommand} [updateEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateEquipmentCommand?: UpdateEquipmentCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEquipmentCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateEquipmentResponsibleUserCommand} [updateEquipmentResponsibleUserCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEquipmentResponsibleUser: async (
      updateEquipmentResponsibleUserCommand?: UpdateEquipmentResponsibleUserCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Equipments/updateEquipmentResponsibleUser`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEquipmentResponsibleUserCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * EquipmentsApi - functional programming interface
 */
export const EquipmentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EquipmentsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi._delete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {AssignEquipmentCommand} [assignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assign(
      assignEquipmentCommand?: AssignEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assign(
        assignEquipmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.assign']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {TallymanConfirmCraneDischargeJobCommand} [tallymanConfirmCraneDischargeJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignToJobByTallyman(
      tallymanConfirmCraneDischargeJobCommand?: TallymanConfirmCraneDischargeJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignToJobByTallyman(
        tallymanConfirmCraneDischargeJobCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.assignToJobByTallyman']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {BulkEquipmentAssignmentCommand} [bulkEquipmentAssignmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkEquipmentAssignmentCommand(
      bulkEquipmentAssignmentCommand?: BulkEquipmentAssignmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bulkEquipmentAssignmentCommand(
        bulkEquipmentAssignmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.bulkEquipmentAssignmentCommand']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async craneQueueStats(
      currentDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CraneQueueDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.craneQueueStats(
        currentDate,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.craneQueueStats']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateEquipmentCommand} [createEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createEquipmentCommand?: CreateEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createEquipmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async equipmentStats(
      currentDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquipmentStatsDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.equipmentStats(currentDate, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.equipmentStats']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {EquipmentType} [equipmentType]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      vesselVisitId?: number,
      equipmentType?: EquipmentType,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquipmentDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        vesselVisitId,
        equipmentType,
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssignedCranesForContainersByVisit(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AssignedCraneForContainerDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAssignedCranesForContainersByVisit(
          carrierVisitId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getAssignedCranesForContainersByVisit']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEquipmentTypes(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquipmentType>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEquipmentTypes(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getEquipmentTypes']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [craneId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getForTallymanOfDischarging(
      carrierVisitId?: number,
      craneId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EquipmentForTallymanSelectionDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getForTallymanOfDischarging(
        carrierVisitId,
        craneId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getForTallymanOfDischarging']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [visitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIdsAlreadyInUseByOtherVisits(
      visitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getIdsAlreadyInUseByOtherVisits(
        visitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getIdsAlreadyInUseByOtherVisits']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLast(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LastEquipmentInteractionDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLast(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getLast']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOne(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EquipmentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOne(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getOne']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOperationalEquipments(
      ids?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationalEquipmentDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationalEquipments(
        ids,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getOperationalEquipments']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlanned(
      carrierVisitId?: number,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EquipmentPlannedDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanned(
        carrierVisitId,
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.getPlanned']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {ReleaseUsersEquipmentCommand} [releaseUsersEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logoutOperatorEquipment(
      releaseUsersEquipmentCommand?: ReleaseUsersEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logoutOperatorEquipment(
        releaseUsersEquipmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.logoutOperatorEquipment']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {TallymanConfirmCraneLoadingJobCommand} [tallymanConfirmCraneLoadingJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tallymanConfirmCraneLoadingJob(
      tallymanConfirmCraneLoadingJobCommand?: TallymanConfirmCraneLoadingJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tallymanConfirmCraneLoadingJob(
        tallymanConfirmCraneLoadingJobCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.tallymanConfirmCraneLoadingJob']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UnassignEquipmentCommand} [unassignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unassign(
      unassignEquipmentCommand?: UnassignEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unassign(
        unassignEquipmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.unassign']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateEquipmentCommand} [updateEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateEquipmentCommand?: UpdateEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        updateEquipmentCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateEquipmentResponsibleUserCommand} [updateEquipmentResponsibleUserCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEquipmentResponsibleUser(
      updateEquipmentResponsibleUserCommand?: UpdateEquipmentResponsibleUserCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEquipmentResponsibleUser(
        updateEquipmentResponsibleUserCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EquipmentsApi.updateEquipmentResponsibleUser']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * EquipmentsApi - factory interface
 */
export const EquipmentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EquipmentsApiFp(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp._delete(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {AssignEquipmentCommand} [assignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assign(
      assignEquipmentCommand?: AssignEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .assign(assignEquipmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {TallymanConfirmCraneDischargeJobCommand} [tallymanConfirmCraneDischargeJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignToJobByTallyman(
      tallymanConfirmCraneDischargeJobCommand?: TallymanConfirmCraneDischargeJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .assignToJobByTallyman(tallymanConfirmCraneDischargeJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {BulkEquipmentAssignmentCommand} [bulkEquipmentAssignmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkEquipmentAssignmentCommand(
      bulkEquipmentAssignmentCommand?: BulkEquipmentAssignmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bulkEquipmentAssignmentCommand(bulkEquipmentAssignmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    craneQueueStats(
      currentDate?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CraneQueueDto>> {
      return localVarFp
        .craneQueueStats(currentDate, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateEquipmentCommand} [createEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createEquipmentCommand?: CreateEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createEquipmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [currentDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    equipmentStats(
      currentDate?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EquipmentStatsDto>> {
      return localVarFp
        .equipmentStats(currentDate, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {EquipmentType} [equipmentType]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      vesselVisitId?: number,
      equipmentType?: EquipmentType,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EquipmentDto>> {
      return localVarFp
        .get(vesselVisitId, equipmentType, includeInactive, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedCranesForContainersByVisit(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<AssignedCraneForContainerDto>> {
      return localVarFp
        .getAssignedCranesForContainersByVisit(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEquipmentTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<EquipmentType>> {
      return localVarFp.getEquipmentTypes(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [craneId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForTallymanOfDischarging(
      carrierVisitId?: number,
      craneId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EquipmentForTallymanSelectionDto>> {
      return localVarFp
        .getForTallymanOfDischarging(carrierVisitId, craneId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [visitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIdsAlreadyInUseByOtherVisits(
      visitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<number>> {
      return localVarFp
        .getIdsAlreadyInUseByOtherVisits(visitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLast(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LastEquipmentInteractionDto> {
      return localVarFp.getLast(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOne(id: number, options?: RawAxiosRequestConfig): AxiosPromise<EquipmentDto> {
      return localVarFp.getOne(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOperationalEquipments(
      ids?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<OperationalEquipmentDto>> {
      return localVarFp
        .getOperationalEquipments(ids, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanned(
      carrierVisitId?: number,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EquipmentPlannedDto>> {
      return localVarFp
        .getPlanned(carrierVisitId, includeInactive, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ReleaseUsersEquipmentCommand} [releaseUsersEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutOperatorEquipment(
      releaseUsersEquipmentCommand?: ReleaseUsersEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .logoutOperatorEquipment(releaseUsersEquipmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {TallymanConfirmCraneLoadingJobCommand} [tallymanConfirmCraneLoadingJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tallymanConfirmCraneLoadingJob(
      tallymanConfirmCraneLoadingJobCommand?: TallymanConfirmCraneLoadingJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .tallymanConfirmCraneLoadingJob(tallymanConfirmCraneLoadingJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UnassignEquipmentCommand} [unassignEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassign(
      unassignEquipmentCommand?: UnassignEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .unassign(unassignEquipmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateEquipmentCommand} [updateEquipmentCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateEquipmentCommand?: UpdateEquipmentCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .update(updateEquipmentCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateEquipmentResponsibleUserCommand} [updateEquipmentResponsibleUserCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEquipmentResponsibleUser(
      updateEquipmentResponsibleUserCommand?: UpdateEquipmentResponsibleUserCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateEquipmentResponsibleUser(updateEquipmentResponsibleUserCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * EquipmentsApi - object-oriented interface
 */
export class EquipmentsApi extends BaseAPI {
  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public _delete(id: number, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      ._delete(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {AssignEquipmentCommand} [assignEquipmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assign(assignEquipmentCommand?: AssignEquipmentCommand, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .assign(assignEquipmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TallymanConfirmCraneDischargeJobCommand} [tallymanConfirmCraneDischargeJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignToJobByTallyman(
    tallymanConfirmCraneDischargeJobCommand?: TallymanConfirmCraneDischargeJobCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .assignToJobByTallyman(tallymanConfirmCraneDischargeJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {BulkEquipmentAssignmentCommand} [bulkEquipmentAssignmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public bulkEquipmentAssignmentCommand(
    bulkEquipmentAssignmentCommand?: BulkEquipmentAssignmentCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .bulkEquipmentAssignmentCommand(bulkEquipmentAssignmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [currentDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public craneQueueStats(currentDate?: string, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .craneQueueStats(currentDate, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateEquipmentCommand} [createEquipmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(createEquipmentCommand?: CreateEquipmentCommand, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .create(createEquipmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [currentDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public equipmentStats(currentDate?: string, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .equipmentStats(currentDate, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [vesselVisitId]
   * @param {EquipmentType} [equipmentType]
   * @param {boolean} [includeInactive]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(
    vesselVisitId?: number,
    equipmentType?: EquipmentType,
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .get(vesselVisitId, equipmentType, includeInactive, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAssignedCranesForContainersByVisit(
    carrierVisitId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .getAssignedCranesForContainersByVisit(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getEquipmentTypes(options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .getEquipmentTypes(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {number} [craneId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getForTallymanOfDischarging(
    carrierVisitId?: number,
    craneId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .getForTallymanOfDischarging(carrierVisitId, craneId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [visitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getIdsAlreadyInUseByOtherVisits(visitId?: number, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .getIdsAlreadyInUseByOtherVisits(visitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [id]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getLast(id?: number, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .getLast(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOne(id: number, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .getOne(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} [ids]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getOperationalEquipments(ids?: Array<number>, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .getOperationalEquipments(ids, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {boolean} [includeInactive]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getPlanned(
    carrierVisitId?: number,
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .getPlanned(carrierVisitId, includeInactive, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ReleaseUsersEquipmentCommand} [releaseUsersEquipmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public logoutOperatorEquipment(
    releaseUsersEquipmentCommand?: ReleaseUsersEquipmentCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .logoutOperatorEquipment(releaseUsersEquipmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {TallymanConfirmCraneLoadingJobCommand} [tallymanConfirmCraneLoadingJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tallymanConfirmCraneLoadingJob(
    tallymanConfirmCraneLoadingJobCommand?: TallymanConfirmCraneLoadingJobCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .tallymanConfirmCraneLoadingJob(tallymanConfirmCraneLoadingJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UnassignEquipmentCommand} [unassignEquipmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public unassign(
    unassignEquipmentCommand?: UnassignEquipmentCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .unassign(unassignEquipmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateEquipmentCommand} [updateEquipmentCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(updateEquipmentCommand?: UpdateEquipmentCommand, options?: RawAxiosRequestConfig) {
    return EquipmentsApiFp(this.configuration)
      .update(updateEquipmentCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateEquipmentResponsibleUserCommand} [updateEquipmentResponsibleUserCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateEquipmentResponsibleUser(
    updateEquipmentResponsibleUserCommand?: UpdateEquipmentResponsibleUserCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return EquipmentsApiFp(this.configuration)
      .updateEquipmentResponsibleUser(updateEquipmentResponsibleUserCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
